import React, { createContext, useContext, useEffect, useState } from "react";

interface AcademyData {
    academyUserName: string;
    academyPassword: string;
    urlAcademy: string;
    academyIsEnabled: boolean
}

interface AcademyContextType extends AcademyData {
    updateAcademyContext: (data: AcademyData) => void;
    academyIsConfigured: () => boolean;
    clearAcademyContext: () => void;
}

const defaultAcademy: AcademyData = {
    academyUserName: "",
    academyPassword: "",
    urlAcademy: "",
    academyIsEnabled: false
};

const AcademyContext = createContext<AcademyContextType>({
    ...defaultAcademy,
    updateAcademyContext: () => { },
    academyIsConfigured: () => false,
    clearAcademyContext: () => { },
});

export const useAcademy = () => useContext(AcademyContext);

export const AcademyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [academyData, setAcademyData] = useState<AcademyData>(defaultAcademy);

    const updateAcademyContext = (data: AcademyData) => {
        setAcademyData(data);
        localStorage.setItem("academyData", JSON.stringify(data));
    };

    const academyIsConfigured = () => {
        const { academyUserName, academyPassword, urlAcademy, academyIsEnabled } = academyData;
        return Boolean(academyUserName && academyPassword && urlAcademy && academyIsEnabled);
    };
    useEffect(() => {
        const storedData = localStorage.getItem("academyData");
        if (storedData) {
            setAcademyData(JSON.parse(storedData));
        }
    }, []);
    const clearAcademyContext = () => {
        setAcademyData(defaultAcademy);
        localStorage.removeItem("academyData");
    };
    return (
        <AcademyContext.Provider
            value={{
                ...academyData,
                updateAcademyContext,
                academyIsConfigured,
                clearAcademyContext
            }}
        >
            {children}
        </AcademyContext.Provider>
    );
};
